import type { FC } from "react";

import { swSettings } from "app/common/services/swSettings";
import WWOSearchTrafficOrganic from "app/pages/website-performance/components/SearchTraffic/organic/WWOSearchTrafficOrganic";
import {
    getBrandedNonBrandedCtaLinkForDS,
    getKeywordsCtaLinkForDS,
} from "app/pages/website-performance/components/SearchTraffic/utlis";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const WWOSearchTrafficOrganicContainerDS: FC = () => {
    const isEligibleForFeatureHookModal = isNoTouchOrTrialOrAfterTrial(swSettings);
    return (
        <WWOSearchTrafficOrganic
            getKeywordsCtaLink={(params) =>
                getKeywordsCtaLinkForDS({
                    ...params,
                    selectedPageTab: EKeywordTabs[EKeywordTabs.Organic],
                })
            }
            getBrandedNonBrandedCtaLink={getBrandedNonBrandedCtaLinkForDS}
            brandedNonBrandedUnlockHook={{
                component: "WsWebSearchOverview",
                hookModal: isEligibleForFeatureHookModal ? "paidSearchOverview" : DEFAULT_HOOKS_MODAL_ID,
                version: getHooksVersion(swSettings),
            }}
            keywordsUnlockHook={{
                component: "WsWebSearchKeywords",
                hookModal: isEligibleForFeatureHookModal ? "keywordResearch" : DEFAULT_HOOKS_MODAL_ID,
                version: getHooksVersion(swSettings),
            }}
        />
    );
};
